import { ReactNode } from 'react'

import { mainColors } from '../../../../../styles'
import { FlexContainer } from '../../../../FlexContainer'
import { MMedium, MNormal } from '../../../../Typography'
import * as S from '../Review.styles'
import { ReviewProps } from '../Review.types'

interface ReviewComment {
  label: string
  content?: ReactNode
  action?: ReactNode
}

export interface ReviewCommentsProps extends Pick<ReviewProps, 'hideComments'> {
  reviewComments: ReviewComment[]
}

export const ReviewComments = ({ reviewComments, hideComments = false }: ReviewCommentsProps) => {
  if (hideComments || !reviewComments.length) return null

  const hasCommentsContent = reviewComments.some(({ content }) => !!content)

  return (
    <S.ReviewCommentContainer $shouldDisplayAsColumn={hasCommentsContent}>
      {reviewComments.map(comment => (
        <FlexContainer key={comment.label} direction="column" alignItems="start" gap={2}>
          <MMedium>{comment.label}</MMedium>
          <FlexContainer justify="start" gap={8}>
            <MNormal color={mainColors.neutralExtremelyDark}>
              {comment.content ?? <i>Not provided</i>}
            </MNormal>
            {comment.action}
          </FlexContainer>
        </FlexContainer>
      ))}
    </S.ReviewCommentContainer>
  )
}
